import { render, staticRenderFns } from "./rangeButton.vue?vue&type=template&id=d20d714e&lang=pug&"
import script from "./rangeButton.vue?vue&type=script&lang=ts&"
export * from "./rangeButton.vue?vue&type=script&lang=ts&"
import style0 from "./rangeButton.vue?vue&type=style&index=0&id=d20d714e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports